import { Injectable } from '@angular/core';
import { AlertService, BlockUiHandlerService } from 'src/app/services';
import { HttpClient, HttpHeaders, NgbModal, Observable } from '../common';
import { ALERTS, AppConstants } from '../common/constants';
import { IConfigNotification } from '../models/i-config-notification';
import { UdfFormats } from '../models/i-udf-formato';
import { BaseResponse, FileResponse, IConfigNotificationResponse, IUdfFormatoResponse, UdfFotmatsResponse } from '../models/responses';
import { StorageService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class ConfigNotificationService {

  constructor(private httpClient: HttpClient, private blockUiService: BlockUiHandlerService, private alertService: AlertService, private storageService: StorageService) { }

  GetByType(Type: string): Observable<IConfigNotificationResponse> {

    const url = `${AppConstants.API_URL}api/Notification/GetConfigFor?pType=${Type}`;

    return this.httpClient.get<IConfigNotificationResponse>(url);
  }


  downloadReportFile(pFileName: string, pConfigType: string) {

    const headers = new HttpHeaders({
      'responseType': 'blob',
      'Content-Type': 'application/json'

    });
    const url = `${AppConstants.API_URL}api/File/downloadFile?pReportName=${pFileName}&pConfigType=${pConfigType}`;
    return this.httpClient.get<FileResponse>(url, { headers });
  }

  Store(pData: FormData): Observable<BaseResponse> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const httpOptions = {
      headers: headers
    };
    const url = `${AppConstants.API_URL}api/Notification/StoreConfig`;
    return this.httpClient.post<BaseResponse>(url, pData, httpOptions);
  }

  Put(_confignotification: IConfigNotification): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Notification/PutConfig`;

    return this.httpClient.post<BaseResponse>(url, _confignotification, { headers });
  }

  //Obtiene info de udf segun la categoría
  GetUdfFormatos(category: string, nameudf: string): Observable<IUdfFormatoResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const url = `${AppConstants.API_URL}api/Notification/GetUdfs?category=${category}&nameudf=${nameudf}`;
    return this.httpClient.get<IUdfFormatoResponse>(url);
  }

  //Guarda configuración de formatos en bd local y reportes en el path 
  SaveUdfFormat(formData: FormData, alertService: AlertService, modalService: NgbModal) {

    const TOKEN = JSON.parse(this.storageService.GetCurrentSession());
    let XHR = new XMLHttpRequest();
    this.blockUiService.Start(1, `Actualizando configuración, espere por favor`);
    XHR.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        let response = JSON.parse(XHR.responseText);
        if (response.Result) {
          alertService.ShowSmallCornerAlert("Formatos de impresión actualizados", ALERTS.success);
          modalService.dismissAll();
        } else {
          alertService.ShowSmallCornerAlert(
            "Error al subir reportes" +
            response.ErrorInfo.Message, ALERTS.error
          );
          modalService.dismissAll();
        }
      }
    };
    const url = `${AppConstants.API_URL}api/Notification/SaveUdfFormat`;
    this.blockUiService.Stop(); // Stop blocking
    XHR.open("POST", url, true);
    XHR.setRequestHeader("Authorization", `Bearer ${TOKEN.access_token}`);
    XHR.send(formData);
  }


  //Obtiene formatos de impresión configurados en la bd local
  GetUdfFormat(): Observable<UdfFotmatsResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const url = `${AppConstants.API_URL}api/Notification/GetUdfFormat`;
    return this.httpClient.get<UdfFotmatsResponse>(url);
  }

}
